import { getTeamStandings } from "../../../api";

export const fetchTeamStandings = async ({
  provider,
  discipline,
  competitionIds = [],
  season,
  day = null,
  statType = 'general',
}) => {
  const { data } = await getTeamStandings({
    provider,
    discipline,
    competitionIds,
    season,
    day,
    statType,
  });

  return data;
};